import React from "react";
import { Box, Grid } from "@material-ui/core";
import useStyles from "./styles";

const ColorPalette = () => {
  const classes = useStyles();
  return (
    <Box className={classes.colorGridContainer}>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignContent="flex-start"
        wrap="wrap"
        className={classes.colorGrid}
      >
        <Grid item xs={12} className={`${classes.colorBox} ${classes.primary}`}>
          Primary
        </Grid>
        <Grid
          item
          xs={4}
          className={`${classes.colorBox} ${classes.secondary}`}
        >
          Secondary
        </Grid>
        <Grid item xs={4} className={`${classes.colorBox} ${classes.warn}`}>
          Warn
        </Grid>
        <Grid item xs={4} className={`${classes.colorBox} ${classes.error}`}>
          Error
        </Grid>
        <Grid item xs={2} className={`${classes.colorBox} ${classes.black}`}>
          Black
        </Grid>
        <Grid item xs={2} className={`${classes.colorBox} ${classes.grayDark}`}>
          Dark Gray
        </Grid>
        <Grid item xs={2} className={`${classes.colorBox} ${classes.grayMed}`}>
          Med Gray
        </Grid>
        <Grid
          item
          xs={2}
          className={`${classes.colorBox} ${classes.grayLight}`}
        >
          Light Gray
        </Grid>
        <Grid
          item
          xs={2}
          className={`${classes.colorBox} ${classes.whiteGray}`}
        >
          White-Gray
        </Grid>
        <Grid item xs={2} className={`${classes.colorBox} ${classes.white}`}>
          White
        </Grid>
      </Grid>
    </Box>
  );
};

export default ColorPalette;
